export const iconFontAwesomeMapsBuildingColumns = (
	<i className="fa-solid fa-building-columns"></i>
);
